import { ButtonProps } from '@material-ui/core';

export const button: ButtonProps = {
  variant: 'contained',
  color: 'primary',
};
